export default __webpack_public_path__ + "static/favicon-7ea632e0e6399ab4c2eb1b880cd299e4.ico";